const validateCPF = (cpf) => {
    // Remove the non-numeric characters
    cpf = cpf.replace(/[^\d]/g, '');

    // Verify if it has 11 digits
    if (cpf.length !== 11) {
        return false;
    }

    // Verify if all digits are the same
    if (/^(\d)\1{10}$/.test(cpf)) {
        return false;
    }

    // Validate the first verification digit
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let digit = 11 - (sum % 11);
    if (digit > 9) digit = 0;
    if (digit !== parseInt(cpf.charAt(9))) {
        return false;
    }

    // Validate the second verification digit
    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    digit = 11 - (sum % 11);
    if (digit > 9) digit = 0;
    if (digit !== parseInt(cpf.charAt(10))) {
        return false;
    }

    return true;
};

export default validateCPF;
